module.exports = __webpack_public_path__ + "img/frame (206).a52d2453.jpg";